(function () {
  gsap.registerPlugin(ScrollTrigger);

  const header = () => document.querySelector('.section-header');
  const bottomBar = () => document.querySelector('.section-bottom-bar');

  function initDarkNav() {
    ScrollTrigger.getAll().forEach((st) => {
      if (st._darkNav) st.kill();
    });

    // Default hardcoded: nav scura ovunque, tranne in home (l'unica pagina che
    // parte con nav chiara) finché nessuna sezione con una regola esplicita
    // (data-dark-nav) è attiva.
    const isHome = !!document.querySelector('[data-barba-namespace="index"]');
    const isMobile = window.matchMedia('(orientation: portrait)').matches;
    const defaultDark = !isHome;
    // Da mobile, fuori dalla home, l'header non cambia colore in base allo
    // scroll: resta con sfondo pieno (vedi sections/_header.scss, .solid).
    const solidHeader = !isHome && isMobile;

    // La bottom bar è scura se lo chiede la sezione sotto di essa, ma sopra il
    // footer resta sempre scura a prescindere (onFooter vince su sectionDark).
    let sectionDark = defaultDark;
    let onFooter = false;
    const applyBottomBar = () => bottomBar()?.classList.toggle('dark', onFooter || sectionDark);

    header()?.classList.toggle('dark', defaultDark);
    header()?.classList.toggle('solid', solidHeader);
    applyBottomBar();

    document.querySelectorAll('[data-dark-nav]').forEach((section) => {
      const isDark = section.dataset.darkNav !== 'false';

      if (!solidHeader) {
        const stHeader = ScrollTrigger.create({
          trigger: section,
          start: 'top top',
          end: 'bottom top',
          // markers: true,
          onToggle: (self) => header()?.classList.toggle('dark', self.isActive ? isDark : defaultDark),
        });
        stHeader._darkNav = true;
      }

      const stBottom = ScrollTrigger.create({
        trigger: section,
        start: 'top bottom',
        end: 'bottom bottom',
        // markers: true,
        onToggle: (self) => {
          sectionDark = self.isActive ? isDark : defaultDark;
          applyBottomBar();
        },
      });
      stBottom._darkNav = true;
    });

    const footer = document.querySelector('.footer');
    if (footer) {
      const stFooter = ScrollTrigger.create({
        trigger: footer,
        // Attivo da quando il footer entra dal fondo della viewport, cioè da
        // quando la bottom bar ci finisce sopra, fino a fine pagina.
        start: 'top bottom',
        end: 'bottom top',
        // markers: true,
        onToggle: (self) => {
          onFooter = self.isActive;
          applyBottomBar();
        },
      });
      stFooter._darkNav = true;
    }
  }

  initDarkNav();

  // Usa page:loaded (dispatchato da page-transitions.js dopo aver killato
  // e refreshato ScrollTrigger) per reinizializzare dopo ogni transizione Barba
  document.addEventListener('page:loaded', () => initDarkNav());
})();
